export default "__VITE_ASSET__Bux9qvCp__"